import React from 'react';
import PropTypes from 'prop-types';

const classNames = require('classnames');

const Row = ({ className = '', children = null }) => {
  const rowClasses = classNames({
    row: true,
    [`${className}`]: className
  });

  return (
    <div className={rowClasses}>
      {children}
    </div>
  );
};

Row.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default Row;
